// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsb1ssb{width:50%}\n._p12fnklw{max-width:20pc}", ""]);
// Exports
module.exports = exports;
